export default __webpack_public_path__ + "static/media/heroImage3.5d5186ff.png";